var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},[_c('span',{ref:'sizeOfLabel',staticClass:"progress-bar__current",style:({
			left:
				_vm.width < 50
					? `calc(${_vm.width}% + 5px)`
					: `calc(${_vm.width}% - ${_vm.offset}px)`,
		})},[_vm._v(_vm._s(_vm.label ? _vm.label : `${_vm.width}%`)+" bonus")]),_vm._v(" "),_c('div',{staticClass:"progress-bar__loader",style:({ width: _vm.width + '%' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }